import React from 'react';
import {motion} from 'framer-motion';
import {
  PaddingContainer,
  Heading,
  BlueText,
} from '../styles/Global.styled';
import { SimpleSlider } from './ui/SimpleSlider';
import { ImageSlider } from './ui/ImageSlider';

import { projectDetails } from '../utils/Data';
import Project from './layouts/Project';
import { fadeInTopVariant, fadeInLeftVariant } from '../utils/Variants';
const MyProjects = () => {
  return (
      <PaddingContainer
        id='projects'
        top='15%'
        bottom='10%'
        left="8%"
        right="8%"
        tabletLeft="1%"
        tabletRight="1%"
        responsiveTop='20%'
        responsiveLeft='1rem'
        responsiveRight='1rem' 
        
      >
          <Heading as={motion.h4} size='h4' variants={fadeInLeftVariant} initial='hidden' whileInView='visible' viewport={{ once: false, amount: 0.4 }}>
              Proyectos
          </Heading>
          <Heading as={motion.h2} size='h2' variants={fadeInLeftVariant} initial='hidden' whileInView='visible' viewport={{ once: false, amount: 0.4 }}>
              Mis <BlueText>Proyectos</BlueText>
          </Heading>
          {projectDetails.map((project) => 
            <PaddingContainer key={project.id} top='5rem' bottom='5rem' responsiveTop='2rem' tabletTop='4rem'>
                  <Project data={project}/>
              </PaddingContainer >
          )}
      </PaddingContainer>
    )
}

export default MyProjects